export default __webpack_public_path__ + "static/media/onboard.07a3cdf8.PNG";